export const MESSAGE_TYPES = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  DANGER: "danger"
};

export const TEMPLATE_TYPES = {
  REFRESH: "REFRESH",
  RELOGIN: "RELOGIN"
};
